import { listQuestions } from "./list_questions";
import { queryArray } from "../events/query";
import { handlePagination } from "./handle_pagination";
export const showQuestions = () => {
  let listsPerPage = 1;
  let answered_questions = queryArray.filter(
    (items) => parseInt(items.answered) === 1
  );

  let not_answered_questions = queryArray.filter(
    (items) => parseInt(items.answered) === 0
  );
  let lists = {
    listsPerPage,
    type: "query",
    containers: {
      pagination: "showQuerypagination",
    },
  };

  // Show not answered questions
  if (not_answered_questions.length < listsPerPage) {
    listQuestions(not_answered_questions, "notAnswered");
  } else {
    lists.data = not_answered_questions;
    lists.containers.main = "notAnswered";
    handlePagination(lists);
  }

  // Show Answered questions
  if (answered_questions.length < listsPerPage) {
    listQuestions(answered_questions, "answered");
  } else {
    lists.data = answered_questions;
    lists.containers.main = "answered";

    handlePagination(lists);
  }
};
